import { Props } from "./Models";

const HeaderView = ({
    title,
    goBack,
    hasLeftButton,
    rightButton,
    leftButton,
    backButtonLabel = "voltar",
}: Props) => {
    return <header className="z-10 w-full bg-white h-[calc(72px)] text-black flex items-center justify-center border-b border-border">
        <div className="relative w-full flex items-center justify-center max-w-[calc(900px)] h-full">
            <h1 className="text-base">{title}</h1>
            {leftButton ? (
                <div className="absolute left-3">
                    {leftButton}
                </div>
            ) : hasLeftButton && (
                <button onClick={goBack} className="absolute left-3">
                    <img
                        src={"/svg/icon-arrow-left.svg"}
                        className="w-6 h-6"
                        alt={backButtonLabel}
                    />
                </button>
            )}
            {rightButton && <div className="absolute right-3">
                {rightButton}
            </div>}
        </div>
    </header>;
}

export default HeaderView;